export class FilterModel {
    entityCode: number;
    year: number;
    version: number;
    typeId: number;
  }
  